export default __webpack_public_path__ + "static/media/careers4a.b4ce1bb6.svg";